module.exports = __webpack_public_path__ + "img/编组 11.70d4cad5.png";